export const validateURL = (string) => {
  try {
    new URL(string);
    return true;
  } catch (err) {
    return false;
  }
}

export const parseServiceStackDate = (str) => {
  var num = parseInt(str.replace('-0000', '').replace(/[^0-9]/g, ""));
  var date = new Date(num);

  return date;
}

export const shortenString = (str, maxLength) => {
  if(str.length <= maxLength) return str;

  return str.substring(0, maxLength - 3) + '...';
}

export const createImageUrl = (imageBase64) => {
  if(!imageBase64) return null;

  return `data:image/png;base64,${imageBase64}`;
}

export const getRolesFromUserRoles = (userRoles) => {
  if(Array.isArray(userRoles)) {
    return userRoles.map(x => x.role);
  }

  return [];
}

export const path = (obj, path) => {
  try{
      return eval("obj." + path);
  } catch(e) {
      return undefined;
  }
}